'use strict';

function getElementHeight(element, excludeBottomMargin) {
  var height = element.offsetHeight + parseInt(getStyle(element, 'marginTop'));

  if (excludeBottomMargin !== false) {
    return height;
  } else {
    return height + parseInt(getStyle(element, 'marginBottom'));
  }
}

function getStyle(el, cssprop) {
  let styleValue;

  if (el.currentStyle) {
    styleValue = el.currentStyle[cssprop];
  }
  else if (document.defaultView && document.defaultView.getComputedStyle) {
    styleValue = document.defaultView.getComputedStyle(el, '')[cssprop];
  }
  else {
    styleValue = el.style[cssprop]
  }

  return (styleValue === 'auto' || !styleValue.length) ? 0 : styleValue;
}

function getVerticalPosition(element) {
  if(element.nodeName === 'HTML') return -window.pageYOffset
  return element.getBoundingClientRect().top + window.pageYOffset;
}

function getDimensions(element) {
  return element.getBoundingClientRect();
}

function getOrientation(){
  return (window.orientation == 0 || window.orientation == 180) ? "portrait" : "landscape";
}

export var dimensions = {
  getElementHeight: getElementHeight,
  getStyle: getStyle,
  getVerticalPosition: getVerticalPosition,
  getDimensions: getDimensions,
  getOrientation: getOrientation
};
